import React, { useRef, useState } from "react";


const Navbar = () => {
  const [scrollAnimation, setScrollAnimation] = useState(false);
  
  // NAVBAR SCROLL ANIMATION FUNCTION
  window.addEventListener("scroll", () =>
    window.scrollY > 100 ? setScrollAnimation(true) : setScrollAnimation(false)
  );

  // CLOSE NAVBAR ON CLICKING NAV LINKS
  const closeNavbar = () => {
    let navLinks = document.querySelector('.navbar-collapse');
    if(navLinks.classList.contains('show')) {
      navLinks.classList.remove('show')
    }
  }


  return (
    <nav
      className={`navbar navbar-expand-lg ${
        scrollAnimation ? "nav-scroll" : null
      }`}
    >
      <div className="container d-flex align-item-center">
        <a className="navbar-brand order-0" href="#" data-aos="zoom-in">
          <img src='/image/dark-logo.png' alt="" />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i className="fa-solid fa-bars-staggered "></i>
        </button>
        <div
          className="collapse navbar-collapse order-2"
          id="navbarSupportedContent"
        >
          <ul
            className="navbar-nav ms-auto mb-2 mb-lg-0 d-flex align-items-center"
            data-aos="zoom-in"
          >
            <li className="nav-item" onClick={closeNavbar}  >
              <a className="nav-link active" aria-current="page" href="#">
                home
              </a>
            </li>
            <li className="nav-item" onClick={closeNavbar} >
              <a className="nav-link " aria-current="page" href="#about">
                About
              </a>
            </li>
            <li className="nav-item" onClick={closeNavbar} >
              <a className="nav-link " aria-current="page" href="#service">
                service
              </a>
            </li>
            <li className="nav-item" onClick={closeNavbar} >
              <a className="nav-link " aria-current="page" href="#team">
                team
              </a>
            </li>
            <li className="nav-item" onClick={closeNavbar} >
              <a className="nav-link " aria-current="page" href="#blog">
                Blog
              </a>
            </li>
            <div className=" d-lg-none d-block w-100">
              <button className="btn btn-primary d-block w-100 d-lg-none d-block mt-5">
                MetaMask Not Available:
              </button>
              <div
                style={{
                  width: "100%",
                  height: "0.5px",
                  backgroundColor: "white",
                }}
                className="mt-4 rounded-4"
              ></div>
              <div className="my-4 nav-icons d-flex gap-5 align-items-center justify-content-center">
                <i className="fa fa-facebook"></i>
                <i className="fa fa-instagram"></i>
                <i className="fa fa-linkedin"></i>
                <i className="fa fa-twitter"></i>
              </div>
            </div>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
